import React from "react";
import VendorDetailsContainer from "../../containers/VendorDetails";

const VendorDetails = () => {
  return (
    <>
      <VendorDetailsContainer />
    </>
  );
};

export default VendorDetails;